// extracted by mini-css-extract-plugin
export default {"RightPanelToggleButton":"RightPanelToggleButton_RightPanelToggleButton__y+vWg","active":"RightPanelToggleButton_active__mcS4z"};